import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLogs } from "../context/LogContext";
import generateHMAC from "../utils/HMAC";
import generateDeviceId from "../utils/GenerateKey";
import { api } from "../utils/api";

const Home = () => {
  const { addLog } = useLogs();
  const navigate = useNavigate();
  const hasRunRef = useRef(false);

  useEffect(() => {
    // Only run once on mount
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    const registerDevice = async () => {
      try {
        // Check if we already have the hash in localStorage to save time
        const storedDeviceKeyHash = localStorage.getItem("deviceKeyHash");
        // Be tolerant: older builds may have stored a raw string (e.g. "a889...") which is NOT valid JSON.
        // Newer builds might have stored JSON-stringified values (e.g. "\"a889...\"").
        let deviceKeyHash = storedDeviceKeyHash;
        if (storedDeviceKeyHash) {
          try {
            deviceKeyHash = JSON.parse(storedDeviceKeyHash);
          } catch {
            deviceKeyHash = storedDeviceKeyHash;
          }
        }

        console.log("deviceKeyHash", deviceKeyHash);
        if (!deviceKeyHash) {
          addLog("Generating device signature...");
          const deviceKeygen = await generateDeviceId();
          deviceKeyHash = await generateHMAC(deviceKeygen);
          // Store as a plain string (avoid needing JSON.parse at read time)
          localStorage.setItem("deviceKeyHash", String(deviceKeyHash));
        } else {
          // Normalize storage format if it was previously JSON-stringified
          localStorage.setItem("deviceKeyHash", String(deviceKeyHash));
        }

        addLog("TLS implementated");
        addLog("Connected to the server");
        addLog("SSL Certificate verified");
        addLog("API call to check if device is registered");
        addLog(`API Request Body: { 
            deviceKeyHash: ${deviceKeyHash},
          }`);

        const fcmToken = "dsd";
        const response = await api.post("/users/is-device-register", {
          deviceKeyHash,
          fcmToken,
        });
        console.log("response", response);
        addLog(
          `API Response: Device Already registered Please Verify Your Face`
        );

        // Store as plain string (avoid extra quotes like `"696a..."`)
        localStorage.setItem("userId", String(response.data.data.userId));

        const consentAccepted = sessionStorage.getItem("consentAccepted");
        const target = response.data.data.hasFaceData
          ? "/verify-scan"
          : "/scan";
        console.log("Navigating to:", target);

        // If device is already registered (has face data), skip consent and go to verify-scan
        if (response.data.data.hasFaceData) {
          sessionStorage.setItem("consentAccepted", "true"); // Auto-accept for registered devices
          return navigate("/verify-scan", { replace: true });
        }

        // For new users, check if consent was already given in this session
        if (consentAccepted) {
          if (target === "/scan") {
            sessionStorage.setItem("canAccessScan", "true");
          }
          return navigate(target, { replace: true });
        } else {
          return navigate("/consent", {
            state: { next: target },
            replace: true,
          });
        }
      } catch (err) {
        console.error("Error during device registration:", err);
        addLog("TLS implementated");
        addLog("Connected to the server");
        addLog("SSL Certificate verified");
        addLog("API call to check if device is registered");
        addLog(`API Error: Device not registered`);
      }
    };

    registerDevice();
  }, [navigate, addLog]); // guarded by hasRunRef, so safe to include addLog
  return (
    <div className="left-content">
      <h2>Welcome to the Home Page</h2>
      <button onClick={() => navigate("/consent")}>Register</button>
      {/* <button onClick={() => navigate("/login")}>Verification</button> */}
    </div>
  );
};

export default Home;
